import React from "react";
import { useLocation } from "react-router-dom";
import { Table, Tag } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

const AttendanceView = () => {
  const location = useLocation();
  const data = location.state?.data || []; // Ensure data is available
  console.log(data);

  dayjs.extend(utc);
  dayjs.extend(timezone);

  // Table columns
  const baseColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
  ];

  // Add conditional columns before scan columns
  if (data[0]?.admission_no && data[0]?.class) {
    baseColumns.push(
      {
        title: "Admission Number",
        dataIndex: "admission_no",
        key: "admission_no",
      },
      {
        title: "Class",
        dataIndex: "class",
        key: "class",
      },
      {
        title: "Section",
        dataIndex: "section",
        key: "section",
      }
    );
  }

  if (data[0]?.qr_no && !data[0]?.admission_no) {
    baseColumns.push({
      title: "Employee Code",
      dataIndex: "qr_no",
      key: "qr_no",
    });
  }

  // Determine the max number of scans dynamically
  const maxScans = Math.max(
    ...data.map((record) => record.attendance_logs?.length || 0),
    0
  );

  // Generate scan columns dynamically
  const scanColumns = Array.from({ length: maxScans }, (_, index) => ({
    title: `${index + 1} Scan`,
    key: `${index + 1}scan`,
    render: (_, record) => {
      const scan = record.attendance_logs[index]?.created_at
        ? dayjs
            .utc(record.attendance_logs[index]?.created_at)
            .tz("Asia/Kolkata")
            .format("h:mm:ss A")
        : null;
      return scan ? (
        <Tag color="green">{scan}</Tag>
      ) : (
        <Tag color="red">Absent</Tag>
      );
    },
  }));

  // Combine base columns and scan columns
  const columns = [...baseColumns, ...scanColumns];

  return (
    <div style={{ padding: 20 }}>
      <h2>Attendance Records</h2>
      <Table
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 10 }}
        scroll={{ x: 1000 }}
      />
    </div>
  );
};

export default AttendanceView;
